module.exports = global["$"] = require("-!/tmp/build_2a27305c/node_modules/babel-loader/lib/index.js??ref--12-0!./jquery.js");